<div class="chat-pin-invite-widget column-flex-container bc-work-item-theme theme-grey" [ngClass]="{ 'expired': workItem.isExpired() }">

  <work-widget-header class="bc-panel column-flex-fix"
                      [workItem]="workItem"
                      [title]="'PIN' + workItem.pinCode | appCharacterGrouper"></work-widget-header>

  <div class="column-flex-grow lane-content" [ngClass]="{ 'ignore-overflow': isExpandedMode() }" data-automation-id="content">
    <div class="col-xs-12 col-sm-12 bc-work-lane" [ngClass]="{ 'col-md-12 col-lg-12': !isExpandedMode(), 'col-md-6 col-lg-6': isExpandedMode() }">
      <div class="bc-panel bc-panel-maxh">
        <div class="text-center panel-content">

          <div class="title text-left bc-panel-header">
            <svg-icon icon="computer" class="bc-panel-header-icon ng-isolate-scope"></svg-icon>

            <span class="bc-panel-header-text" [attr.data-automation-id]="'bc-pin-invite-header-text'">{{ workItem.title | translate }}</span>

            <button (click)="onCancelInviteClick()"
                    class="btn btn-light cancel pull-right"
                    data-automation-id="pin-invite-cancel-button">
              {{ 'chatPinInviteWidget.cancelInvite' | translate }}
            </button>
          </div>

          <div class="inner-content">
            <div class="agent">
              <svg-icon icon="agent-head"></svg-icon>
            </div>
            <div class="dotted"></div>

            <div class="subtitle">
              <span *ngIf="!workItem.isExpired()">
                <span>{{ 'chatPinInviteWidget.pinCode' | translate }}</span>
                (<span>{{ 'chatPinInviteWidget.expiresIn' | translate }} </span>
                 <app-countdown-timer [countUntilTime]="workItem.expiringAt"></app-countdown-timer>)
              </span>
              <span *ngIf="workItem.isExpired()"
                    class="expired-message"
                    data-automation-id="pin-expired-message">{{ 'chatPinInviteWidget.pinExpired' | translate }}</span>
            </div>

            <div class="pin" [attr.data-automation-id]="'bc-pin-invite-pin-code'">
              {{ workItem.pinCode | appCharacterGrouper }}
            </div>
            <div class="dotted"></div>

            <div class="computer">
              <svg-icon icon="computer"></svg-icon>
            </div>

            <div class="instructions-container">
              <div class="instructions">
                <div>{{ 'chatPinInviteWidget.instructionLine1' | translate }}</div>

                <ul>
                  <li>
                    <svg-icon icon="dot"></svg-icon>
                    <span>{{ 'chatPinInviteWidget.instructionLine2' | translate }}</span>
                  </li>
                  <li>
                    <svg-icon icon="dot"></svg-icon>
                    <span>{{ 'chatPinInviteWidget.instructionLine3' | translate: { pinCode: workItem.pinCode } }}</span>
                  </li>
                </ul>

                <div>{{ 'chatPinInviteWidget.instructionLine4' | translate }}</div>
                <div>{{ 'chatPinInviteWidget.instructionLine5' | translate }}</div>

                <div class="notes">{{ 'chatPinInviteWidget.instructionLine6' | translate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
